//
import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

type AuthReducerState = Readonly<{
  isLoading: boolean;
  error: null | Error;
}>;

const initialState: Readonly<AuthReducerState> = {
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.LOGIN_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.LOGIN_SUCCESS]: (state = initialState) => ({
    ...state,
    isLoading: false
  }),
  [c.LOGIN_ERROR]: (state = initialState, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.LOGOUT_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.LOGOUT_SUCCESS]: (state = initialState) => ({
    ...state,
    isLoading: false
  }),
  [c.LOGOUT_ERROR]: (state = initialState, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.REGISTER_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.REGISTER_SUCCESS]: (state = initialState) => ({
    ...state,
    isLoading: false
  }),
  [c.REGISTER_ERROR]: (state = initialState, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.FORGOT_PASSWORD_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.FORGOT_PASSWORD_SUCCESS]: (state = initialState) => ({
    ...state,
    isLoading: false
  }),
  [c.FORGOT_PASSWORD_ERROR]: (state = initialState, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.RESET_PASSWORD_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.RESET_PASSWORD_SUCCESS]: (state = initialState) => ({
    ...state,
    isLoading: false
  }),
  [c.RESET_PASSWORD_ERROR]: (state = initialState, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
